import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from "@angular/common/http";
import { global } from '../../shared/global';

@Injectable({
  providedIn: 'root'
})
export class RegistrationService {

  constructor(private http: HttpClient) { }
  public httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

  fillBoard(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillBoard', data, global.httpOptions);
  }

  fillMedium(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillMedium', data, global.httpOptions);
  }

  fillInstituteType(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillInstituteType', data, global.httpOptions);
  }

  fillOffice(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillOffice', data, global.httpOptions);
  }

  fillTypeOfTrust(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillTypeOfTrust', data, global.httpOptions);
  }

  fillSection(data) {
    return this.http.post(global.baseAPIUrl + 'Registration/fillSection', data, global.httpOptions);
  }

  fillState(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillState', data, global.httpOptions);
  }

  fillCity(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillCity', data, global.httpOptions);
  }

  fillSchoolType(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillSchoolType', data, global.httpOptions);
  }

  fillSchoolLocation(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillSchoolLocation', data, global.httpOptions);
  }

  fillDesignation(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillDesignation', data, global.httpOptions);
  }

  fillYear(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillYearMaster', data, global.httpOptions);
  }

  fillInfrastructure(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillInfrastructure', data, global.httpOptions);
  }
  fillEmployeeType(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillEmployeeType', data, global.httpOptions);
  }

  fillEmployeeQualificationType(data) {
    return this.http.post(global.baseAPIUrl + 'DropDown/fillQualificationType', data, global.httpOptions);
  }
  // FillArea(data)
  // {
  //   return this.http.post(global.baseAPIUrl + 'DropDown/fillArea', data, global.httpOptions);
  // }

  fillRegistrationDetail(data) {
    this.httpOptions = {
      headers: new HttpHeaders({
          'UserID': localStorage.getItem("userID"),
          'ComponentName': "registrationlist",
          'Operation': "edit",
      })
  }
    return this.http.post(global.baseAPIUrl + 'Registration/fillRegistrationDetail', data, this.httpOptions);
  }

  saveRegistrationDetails(data) {
    this.httpOptions = {
      headers: new HttpHeaders({
          'UserID': localStorage.getItem("userID"),
          'ComponentName': "registrationlist",
          'Operation': "add",
      })
  }
    return this.http.post(global.baseAPIUrl + 'Registration/saveRegistrationDetails', data, this.httpOptions);
  }

}
